module.exports = __webpack_public_path__ + "static/img/4.8cd26e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/zh/4.png
// module id = /AnD
// module chunks = 0